import React from "react"
import { useState, useEffect } from "react"
import { Outlet } from "react-router-dom"
import { useRefreshToken, useAuth } from "../../hooks"

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true)
  const refresh = useRefreshToken()
  const { accessToken } = useAuth()

  const verifyRefreshToken = async () => {
    try {
      await refresh()
    } catch (e) {}
    setIsLoading(false);
  }

  useEffect(() => {
    if (!accessToken?.current) verifyRefreshToken()
    else setIsLoading(false)
  }, [])

  return (
    <>
      {isLoading
        ? <p>Loading..</p> // Add spinner here
        : <Outlet />
      }
    </>
  )
}

export default PersistLogin